var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"watch"},[(true)?_c('Player',{attrs:{"stream-key":_vm.streamKey}}):_vm._e(),_c('Footer',{attrs:{"name":_vm.channel,"online-users":_vm.onlineUsers}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }